import React, { useEffect, useState } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { getAffiliationAssureConnecte, getIndividuListForManage, isAffiliationLoading } from '../../../webservices/affiliation/affiliationSelector'
import { profileSelector, userSelector } from '../../user/userSelectors'
import * as affiliationActions from '../../../webservices/affiliation/affiliationActions'
import * as remboursementsActions from '../../../webservices/remboursements/remboursementsActions'
import { useBreakpoints } from '../../../../components/breakpoints/BreakpointsProvider'
import * as demandeActions from '../../../webservices/demandes/demandesActions'
import { getDernieresDemandes, isDemandesLoading } from '../../../webservices/demandes/demandesSelectors'
import { getDerniersRemboursements, isLoading } from '../../../webservices/remboursements/remboursementsSelector'
import Loader from '../../../../components/Loader'
import DashboardMobile from '../components/dashboardLayout/DashboardMobile'
import DashboardTabletPortrait from '../components/dashboardLayout/DashboardTabletPortrait'
import DashboardTablet from '../components/dashboardLayout/DashboardTablet'
import DashboardLaptop from '../components/dashboardLayout/DashboardLaptop'
import DashboardComputer from '../components/dashboardLayout/DashboardComputer'
import * as contratsActions from '../../../webservices/contrats/contratsActions'
import { isContratsLoading } from '../../../webservices/contrats/contratsSelector'

const DashboardPage = (
	{
		// @ts-ignore
		user,
		// @ts-ignore
		refundLoading,
		// @ts-ignore
		notifications,
		// @ts-ignore
		remboursements,
		// @ts-ignore
		demandes,
		// @ts-ignore
		forceGetDemandes,
		// @ts-ignore
		getDerniersRemboursements,
		// @ts-ignore
		getAffiliation,
		// @ts-ignore
		beneficiaires,
		// @ts-ignore
		affiliationLoading,
		// @ts-ignore
		loadContrats,
		// @ts-ignore
		isContratsLoading,
		// @ts-ignore
		isDemandesLoading
	}
) => {
	useEffect(() => {
		forceGetDemandes()
		getAffiliation()
		getDerniersRemboursements()
		loadContrats()
		setLoading(false)
	}, [forceGetDemandes, getAffiliation, getDerniersRemboursements, loadContrats])

	const { isMobile, isLaptop, isTablet, isTabletPortrait } = useBreakpoints()

	const [loading, setLoading] = useState<boolean>(true)

	const affiliationExpired = user?.affiliationExpired

	// Les demandes sont rafraîchies à chaque arrivée sur l'accueil : on ne bloque le rendu que si le store est
	// encore vide (première arrivée de la session). Sinon on affiche les données précédentes, la carte
	// « Mes demandes » portant elle-même son loader le temps du rafraîchissement.
	const demandesFirstLoad = isDemandesLoading && (!notifications || notifications.length === 0)

	if (loading || affiliationLoading || refundLoading || isContratsLoading || demandesFirstLoad) {
		return <Loader />
	}

	const renderDashboard = () => {
		if (isMobile) {
			return (
				<DashboardMobile
					affiliationExpired={affiliationExpired}
					notifications={notifications}
					remboursements={remboursements}
					user={user}
					demandes={demandes}
					beneficiaires={beneficiaires}
				/>
			)
		} else if (isTabletPortrait) {
			return (
				<DashboardTabletPortrait
					affiliationExpired={affiliationExpired}
					notifications={notifications}
					remboursements={remboursements}
					user={user}
					demandes={demandes}
					beneficiaires={beneficiaires}
				/>
			)
		} else if (isTablet) {
			return (
				<DashboardTablet
					affiliationExpired={affiliationExpired}
					notifications={notifications}
					remboursements={remboursements}
					user={user}
					demandes={demandes}
					beneficiaires={beneficiaires}
				/>
			)
		} else if (isLaptop) {
			return (
				<DashboardLaptop
					affiliationExpired={affiliationExpired}
					notifications={notifications}
					remboursements={remboursements}
					user={user}
					demandes={demandes}
					beneficiaires={beneficiaires}
				/>
			)
		} else {
			return (
				<DashboardComputer
					affiliationExpired={affiliationExpired}
					notifications={notifications}
					remboursements={remboursements}
					user={user}
					demandes={demandes}
					beneficiaires={beneficiaires}
				/>
			)
		}
	}

	return (
		<>
			{renderDashboard()}
		</>
	)
}

const actions = {
	getAffiliation: affiliationActions.getAffiliation,
	downloadAttestationAffiliation: affiliationActions.downloadAttestationAffiliation,
	downloadAttestationRadiation: affiliationActions.downloadAttestationRadiation,
	getDerniersRemboursements: remboursementsActions.getDerniersRemboursements,
	forceGetDemandes: demandeActions.forceGetDemandes,
	loadContrats: contratsActions.loadContrats
}

const mapStateToProps = (state: any) => {
	const derniersRemboursementsSelector = getDerniersRemboursements(3)
	const dernieresDemandes = getDernieresDemandes(3)
	return ({
		user: userSelector(state),
		profile: profileSelector(state),
		assurePrincipal: getAffiliationAssureConnecte(state),
		remboursements: derniersRemboursementsSelector(state),
		demandes: dernieresDemandes(state),
		notifications: state.demandes.data,
		// @ts-ignore
		beneficiaires: getIndividuListForManage(state),
		affiliationLoading: isAffiliationLoading(state),
		refundLoading: isLoading(state),
		isContratsLoading: isContratsLoading(state),
		isDemandesLoading: isDemandesLoading(state)
	})
}

export default compose(
	connect(mapStateToProps, actions)
)(DashboardPage)

